'use client'

import { useEffect, useState } from 'react'
import { FloatingWhatsApp } from 'react-floating-whatsapp'
import { Button, Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'

import { saveUTMToSessionStorage } from '@/lib/utm'

import front from './front.png'
import back from './back.png'

interface TawkToProps {
  resources: any
}

export const TawkTo = ({ resources }: TawkToProps) => {
  const [profile, setProfile] = useState<any>()
  let [isOpen, setIsOpen] = useState(false)
  const [alertOpen, setAlertOpen] = useState(false)

  function open() {
    setIsOpen(true)
  }

  function close() {
    setIsOpen(false)
  }

  useEffect(() => {
    const url = new URL(window.location.href)
    const isStudentskiPohod = url.searchParams.get('utm_source') === 'studentski-pohodi'
    if (isStudentskiPohod) {
      // setIsOpen(true)
    }

    try {
      const profile = JSON.parse(localStorage.getItem('profile') || '{}')
      setProfile(profile)
    } catch (e) {
      setProfile({})
    }

    saveUTMToSessionStorage()
  }, [])

  if (!profile) {
    return null
  }

  return (
    <>
      <Dialog open={alertOpen} as='div' className='relative z-[9999] focus:outline-none' onClose={close}>
        <DialogBackdrop className='fixed inset-0 bg-black/30' />
        <div className='fixed inset-0 z-10 w-screen overflow-y-auto'>
          <div className='flex min-h-full items-center justify-center p-4'>
            <DialogPanel transition className='w-full max-w-md rounded-xl bg-white p-6 backdrop-blur-2xl duration-300 ease-out data-closed:transform-[scale(95%)] data-closed:opacity-0'>
              <DialogTitle as='h3' className='text-base/7 font-medium text-gray-900 pb-4'>
                Radovi na sistemu
              </DialogTitle>
              <p className='mt-2 text-sm/6 text-gray-900'>
                Dana <strong>21.04.2026 od 22:00</strong>, obavljati će se radovi na sistemu, te su mogući povremeni prekidi i greške u radu. Za hitne situacije, kontaktirajte našu podršku putem
                WhatsApp-a.
              </p>

              <hr className='my-4' />

              <div className='mt-4'>
                <Button
                  className='inline-flex items-center gap-2 rounded-md bg-gray-700 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-inner shadow-white/10 focus:not-data-focus:outline-none data-focus:outline data-focus:outline-white data-hover:bg-gray-600 data-open:bg-gray-700'
                  onClick={() => setAlertOpen(false)}
                >
                  Zatvori
                </Button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>

      {false && (
        <Dialog open={isOpen} as='div' className='relative z-[9999] focus:outline-none' onClose={close}>
          <DialogBackdrop className='fixed inset-0 bg-black/30' />
          <div className='fixed inset-0 z-10 w-screen overflow-y-auto'>
            <div className='flex min-h-full items-center justify-center p-4'>
              <DialogPanel transition className='w-full max-w-md rounded-xl bg-white p-6 backdrop-blur-2xl duration-300 ease-out data-closed:transform-[scale(95%)] data-closed:opacity-0'>
                <DialogTitle as='h3' className='text-base/7 font-medium text-gray-900 pb-4'>
                  Novoooo u ponudi: Dopunjiva sim kartica za sve destinacije koja važi 365 dana
                </DialogTitle>

                <div className='flex justify-center items-center gap-4 mb-4'>
                  <img src={front.src} alt='front' width={150} height={150} className='rounded-xl' />
                  <img src={back.src} alt='back' width={150} height={150} className='rounded-xl' />
                </div>

                <div className=' rounded-xl p-6 space-y-4 text-gray-800'>
                  {/* <h2 className='text-xl font-semibold text-gray-900'>Sve što trebaš znati o našoj SIM kartici</h2> */}

                  <div className='flex items-start gap-3'>
                    <span className='text-green-600 text-xl'>✅</span>
                    <p className='text-sm sm:text-base'>
                      <strong>Jednokratna kupovina kartice</strong> – SIM karticu plaćaš samo prvi put. Nakon toga je koristiš isključivo za dopune: bilo da putuješ u novu zemlju ili trebaš dodatni
                      internet na postojećoj destinaciji.
                    </p>
                  </div>

                  <div className='flex items-start gap-3'>
                    <span className='text-blue-600 text-xl'>🔄</span>
                    <p className='text-sm sm:text-base'>
                      <strong>Neograničene dopune</strong> – Karticu možeš nadopunjavati koliko god puta želiš, bez ikakvih ograničenja.
                    </p>
                  </div>

                  <div className='flex items-start gap-3'>
                    <span className='text-purple-600 text-xl'>📆</span>
                    <p className='text-sm sm:text-base'>
                      <strong>Vrijedi 365 dana od prvog korištenja</strong> – Kartica vrijedi godinu dana od trenutka kada je prvi put aktiviraš na putovanju, a ne od dana kupovine.
                    </p>
                  </div>

                  <div className='flex items-start gap-3'>
                    <span className='text-yellow-500 text-xl'>👨‍👩‍👧‍👦</span>
                    <p className='text-sm sm:text-base'>
                      <strong>Dijeljiva s porodicom i prijateljima</strong> – Kartica nije vezana za tvoj broj telefona ili uređaj. Možeš je slobodno podijeliti s drugima – idealna za zajednička
                      putovanja!
                    </p>
                  </div>
                </div>

                <div className='flex items-start gap-3 mb-6'>
                  <p className='text-sm sm:text-base font-semibold text-red-600'>Narudžbe primamo do subote, 30. augusta, do 23:59 sati. Osiguraj svoju SIM karticu na vrijeme!</p>
                </div>
                <div className='mt-4'>
                  <Button
                    className='inline-flex items-center gap-2 rounded-md bg-gray-700 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-inner shadow-white/10 focus:not-data-focus:outline-none data-focus:outline data-focus:outline-white data-hover:bg-gray-600 data-open:bg-gray-700'
                    onClick={close}
                  >
                    Zatvori
                  </Button>
                </div>
              </DialogPanel>
            </div>
          </div>
        </Dialog>
      )}
      <FloatingWhatsApp
        phoneNumber='+38761603225'
        accountName='eSIMFly'
        avatar='/support.png'
        buttonClassName='!left-8'
        statusMessage={resources['Layout.Text.WhatsAppStatus']}
        chatMessage={resources['Layout.Text.WhatsAppChatMessage']}
        placeholder={resources['Layout.Text.WhatsAppMessagePlaceholder']}
      />
    </>
  )
}
